import { globalTheme, createTheme } from '@cld/component-theme';

const { palette, radius } = globalTheme;

export const theme = createTheme({
  size: {
    sm: {
      width: '100px',
      height: '100px',
    },
    md: {
      width: '136px',
      height: '136px',
    },
  },
  background: {
    color: {
      base: palette.surface,
      hover: palette.surface,
      active: palette.primary,
      focus: palette.primary,
      disabled: palette.surface,
    },
  },
  border: {
    color: {
      base: 'transparent',
      hover: 'transparent',
      active: palette.primary,
      focus: palette.primary,
      disabled: 'transparent',
    },
    radius: radius.lg,
  },
  font: {
    color: {
      base: palette.contrastHigh,
      hover: palette.contrastHigh,
      active: palette.contrastHigh,
      focus: palette.contrastHigh,
      disabled: palette.contrastHigh,
    },
  },
});
